export default {
  translation: {
    "nav.home": "Home",
    "nav.guide": "Guida",
    "nav.categories": "Categorie",
    "nav.articles": "Articoli",
    "hero.title": "Itaobuy Spreadsheet Italia",
    "hero.subtitle": "La guida completa per trovare prodotti migliori, offerte e acquisti sicuri",
    "hero.description": "Scopri il metodo più semplice per utilizzare Itaobuy Spreadsheet, trovare prodotti verificati con immagini QC, confrontare prezzi e acquistare in modo intelligente.",
    "hero.cta_primary": "itaobuy sheet",
    "hero.cta_secondary": "buy it now",
    "hero.trust_1": "Aggiornamenti frequenti",
    "hero.trust_2": "Guide in italiano",
    "hero.trust_3": "Tabelle comparative",
    "hero.trust_4": "Consigli sicurezza",
    "categories.title": "Esplora le Categorie",
    "categories.subtitle": "Scopri tutte le categorie di prodotti disponibili",
    "categories.select": "Seleziona una categoria...",
    "articles.title": "Le Nostre Guide",
    "articles.subtitle": "Articoli approfonditi per aiutarti a fare acquisti migliori",
    "articles.read_more": "Leggi l'articolo",
    "trust.title": "Opinioni Verificate",
    "trust.quote": "Itaobuy Spreadsheet ha rivoluzionato il modo in cui faccio acquisti. Finalmente uno strumento chiaro, organizzato e sempre aggiornato per trovare i prodotti migliori.",
    "trust.author": "Marco R.",
    "trust.role": "Acquirente verificato",
    "faq.title": "Domande Frequenti",
    "faq.subtitle": "TUTTO CIÒ CHE DEVI SAPERE",
    "faq.q1": "Cos'è Itaobuy Spreadsheet?",
    "faq.a1": "Itaobuy Spreadsheet è uno strumento organizzato che permette agli utenti di trovare rapidamente prodotti selezionati, confrontare informazioni e scegliere articoli con maggiore sicurezza. Contiene liste di prodotti verificati con immagini QC, prezzi e valutazioni.",
    "faq.q2": "Come funziona Itaobuy Spreadsheet?",
    "faq.a2": "Basta accedere allo spreadsheet, cercare il prodotto desiderato per categoria, analizzare le informazioni disponibili come immagini QC e prezzi, confrontare le opzioni e procedere all'acquisto in modo informato.",
    "faq.q3": "Itaobuy Spreadsheet è sicuro?",
    "faq.a3": "Sì, Itaobuy Spreadsheet è progettato per offrire prodotti verificati. Ogni articolo include immagini QC reali e informazioni dettagliate per permetterti di valutare la qualità prima dell'acquisto. Seguendo le guide, puoi acquistare in totale sicurezza.",
    "faq.q4": "Dove trovo Itaobuy Spreadsheet aggiornato?",
    "faq.a4": "Puoi accedere all'ultima versione di Itaobuy Spreadsheet attraverso il sito principale. Lo spreadsheet viene aggiornato regolarmente con nuovi prodotti, categorie e informazioni verificate.",
    "faq.q5": "Come controllare le QC foto?",
    "faq.a5": "Le QC (Quality Check) foto sono immagini reali dei prodotti scattate prima della spedizione. Nello spreadsheet trovi queste foto per ogni prodotto, permettendoti di verificare qualità, dettagli, colori e rifiniture prima di completare l'ordine.",
    "faq.q6": "Quali prodotti posso trovare?",
    "faq.a6": "Itaobuy Spreadsheet copre numerose categorie: scarpe, felpe, t-shirt, giacche, pantaloni, cappelli, set completi, intimo, maglie sportive, accessori, borse, cinture, profumi e molto altro.",
    "faq.q7": "Itaobuy Spreadsheet è gratuito?",
    "faq.a7": "Itaobuy Spreadsheet offre accesso a una vasta gamma di prodotti e informazioni. Per i dettagli su prezzi e abbonamenti, ti invitiamo a visitare il sito principale dove troverai tutte le informazioni aggiornate.",
    "faq.q8": "Posso usare Itaobuy Spreadsheet dall'Italia?",
    "faq.a8": "Assolutamente sì. Itaobuy Spreadsheet è accessibile dall'Italia e le guide sono disponibili in italiano per aiutarti a navigare tra i prodotti e fare acquisti in modo semplice e sicuro.",
    "faq.q9": "Ogni quanto viene aggiornato lo spreadsheet?",
    "faq.a9": "Itaobuy Spreadsheet viene aggiornato frequentemente con nuovi prodotti, categorie e informazioni. Il team lavora costantemente per garantire che i dati siano sempre freschi e accurati.",
    "cta.title": "Pronto a scoprire i prodotti migliori?",
    "cta.description": "Accedi ora a itaobuy sheet ed esplora la collezione completa di prodotti verificati con le migliori offerte disponibili.",
    "cta.button_primary": "itaobuy sheet",
    "cta.button_secondary": "buy it now",
    "footer.description": "Itaobuy Spreadsheet Italia è il portale di riferimento per trovare prodotti verificati, guide complete e consigli per acquisti sicuri. Tutti i link portano al sito principale per un'esperienza di acquisto completa.",
    "footer.newsletter": "NEWSLETTER",
    "footer.newsletter_placeholder": "La tua email",
    "footer.newsletter_hint": "Ricevi aggiornamenti e nuovi prodotti",
    "footer.links": "LINK",
    "footer.link_home": "Home",
    "footer.link_guide": "Guida",
    "footer.link_articles": "Articoli",
    "footer.social": "SOCIAL",
    "footer.copyright": "© 2026 Itaobuy Spreadsheet Italia. Tutti i diritti riservati.",
    "article.back_home": "← Torna alla home",
    "article.read_time": "Tempo di lettura: 12 minuti",
    "article.category": "Guida",
  }
};